import {Button} from "@mui/material";
import CurrencyFormatter from "../../../../../components/CurrencyFormatter/CurrencyFormatter";
import React from "react";
import {ButtonProps} from "@mui/material/Button/Button";

interface Props extends ButtonProps {
    currentAmount: number | "";
    amount: number;
    fn: (value:number)=> void;
}

export const AmountButton: React.FC<Props> = (props) => {
    const {amount, currentAmount, fn, children,...restProps} = props;
    return (<Button sx={{...(currentAmount === amount ? {
        background: (theme) => theme.palette.primary.main,
        color: (theme) => theme.palette.primary.contrastText,
        '&:hover': {
            background: (theme) => theme.palette.primary.main
        }
    } : {color: '#000'}),fontSize:{xs:'0.800rem',md:'0.875rem'},display:'flex',flexBasis:'25%',whiteSpace:'nowrap'}} onClick={()=> fn(amount)} {...restProps}>
        <CurrencyFormatter currency={'EUR'}
                           quantity={amount}/>
    </Button>);
}